const partners_CN_Locale = {
    'partners.partners': '合作伙伴',
    'partners.swiper1title': '比尔及梅琳达·盖茨基金会',
    'partners.swiper1content1': '比尔及梅琳达·盖茨基金会(Bill & Melinda Gates Foundation)，在比尔·盖茨和夫人梅琳达·盖茨以及沃伦·巴菲特的指导下，致力于在全球范围内抗击疾病、贫困和不平等现象。',
    'partners.swiper1content2': '2024年，度影与比尔及梅琳达·盖茨基金会与达成合作。这是一次旨在为非洲贫困地区的孕妇，带去原在中高水平国家才可能普及的产前超声筛查技术合作，是科技与人文的握手。为此，度影将克服技术、成本等重重困难，与盖茨基金会携手，跨越大半个地球，用AI拥抱新生。',
    'partners.swiper2title': "理邦精密仪器股份有限公司",
    "partners.swiper2content1": "理邦精密仪器股份有限公司 (Edan Instruments, Inc.) 是一家服务于人类健康事业的国际型公司。理邦仪器致力于为医疗机构提供贴近临床需求的优质产品和解决方案，涵盖病人监护、心电产品、超声影像、妇幼健康、体外诊断、智慧健康等方向的百余款创新型，已与近四万家医疗机构形成了紧密的合作关系。",
    "partners.swiper2content2": "度影医疗与理邦仪器已达成深度合作，携手共进，围绕智能化超声等领域进行深度合作，持续创造高品质的超声设备精品，让智慧医疗创新成果惠及每一位医生、每一位患者。"
}
export default partners_CN_Locale
